import React, { useState } from "react";
import { CellTmpl, DEFAULT_PAYLOAD, reactFormatter } from "../../../common/Table";
import StateDetails from "./StateDetails";
import { useGetStates, useDeleteState } from "../../../../backend/masters";
import { useExportStates } from "../../../../backend/exports";
import BaseList from "../../../common/BaseList";
import AddEditState from "./AddEditState";
import { StateSchema } from "../../../../models/state";

function State() {
    const [breadcrumb] = useState([
        { id: 'home', label: 'Home', path: '/' },
        { id: 'masters', label: 'Masters', path: '/masters/act' },
        { id: 'state', label: 'State' }
    ]);

    const columns = [
        { title: "Code", field: "code", formatter: reactFormatter(<CellTmpl />) },
        { title: "Name", field: "name", widthGrow: 2, formatter: reactFormatter(<CellTmpl />) }
    ]

    return (
        <BaseList
            fetchData={useGetStates}
            exportData={useExportStates}
            deleteData={useDeleteState}
            nameAttribute={'name'}
            columns={columns}
            DetailView={StateDetails}
            FormView={AddEditState}
            modelSchema={StateSchema}
            initialSort={['name asc']}
            breadcrumb={breadcrumb}
            title="Mastsers - States"
        />
    )
}

export default State;
